import {
  createValidation,
  validatorRequired,
  validatorMaxLength,
} from '../../utils/formValidators';

import { generalFormFields } from '../../constants/formsAddEquipment';

const eicwCodeValidator = (value, values, props) =>
  props.isAdmin ? validatorRequired()(value, values, props) : undefined;

const localityRequiredValidator = (value, values, props) =>
  props.isHydrogenContext
    ? undefined
    : validatorRequired()(value, values, props);

const zipCodeRequiredValidator = (value, values, props) =>
  props.isHydrogenContext
    ? undefined
    : validatorRequired()(value, values, props);

export default createValidation([
  {
    name: generalFormFields.NAME,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorMaxLength(40)(field),
    ],
  },
  {
    name: generalFormFields.EICW_CODE,
    validators: (value, values, props) =>
      eicwCodeValidator(value, values, props),
  },
  {
    name: generalFormFields.ADDRESS,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorMaxLength(40)(field),
    ],
  },
  {
    name: generalFormFields.LOCALITY,
    validators: (value, values, props) =>
      localityRequiredValidator(value, values, props),
  },
  {
    name: generalFormFields.LOCALITY,
    validators: (field) => validatorMaxLength(150)(field),
  },
  {
    name: generalFormFields.ZIP_CODE,
    validators: (value, values, props) =>
      zipCodeRequiredValidator(value, values, props),
  },
  {
    name: generalFormFields.ZIP_CODE,
    validators: (field) => validatorMaxLength(10)(field),
  },
  {
    name: generalFormFields.FIRST_TIME_USE,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: generalFormFields.IS_INVESTMENT_SUPPORT,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: generalFormFields.AMOUNT_OF_INVESTMENT,
    validators: (field, form) =>
      form.get(generalFormFields.IS_INVESTMENT_SUPPORT)
        ? validatorRequired()(field)
        : '',
  },
]);
